import MobileAnchor from './mobileAnchor';
import React from 'react';

function HeadlineHeader({ article }) {
  return (
    <header className="headline-header margin-bottom-lg">
      <div className="background" style={article.imageBackground}>
        <div className="container">
          <div className="row">
            <aside className="sidebar">&nbsp;</aside>
            <article className="content margin-top-xlg">
              <img
                alt="Quirin Privatbank"
                src="/system/images/385/original/QBA_Logo_RGB_transparent_200x199.png"
                width="150"
                className="img-responsive center-x"
              />
              <h1 className="margin-top-md text-center">{article.landingpage.headline1}</h1>
            </article>
            <aside className="spacebar">&nbsp;</aside>
          </div>
        </div>
      </div>

      {article.landingpage.phoneNumber && <MobileAnchor article={article} />}
    </header>
  );
}

HeadlineHeader.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

export default HeadlineHeader;



// WEBPACK FOOTER //
// ./components/landingpage/headlineHeader.js